import { forwardRef, type Ref, type SVGProps } from "react";
const IconCalendarClockOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M25.89 24.45A1 1 0 0 1 25 25a.93.93 0 0 1-.45-.11L22 23.62V21a1 1 0 0 1 2 0v1.38l1.45.73a1 1 0 0 1 .44 1.34"
    />
    <path
      fill="currentColor"
      d="M26 16.68V7a3 3 0 0 0-3-3h-1V3a1 1 0 0 0-2 0v1H8V3a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h11.68A7 7 0 1 0 26 16.68M4 7a1 1 0 0 1 1-1h1v2a1 1 0 0 0 2 0V6h12v2a1 1 0 0 0 2 0V6h1a1 1 0 0 1 1 1v4H4Zm1 17a1 1 0 0 1-1-1V13h20v3.08a6.6 6.6 0 0 0-1-.08 7 7 0 0 0-7 7 6.6 6.6 0 0 0 .08 1Zm18 4a5 5 0 1 1 5-5 5 5 0 0 1-5 5"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCalendarClockOutlineSVG);
ForwardRef.displayName = "IconCalendarClockOutline";
export { ForwardRef as IconCalendarClockOutline };
